import { create } from 'zustand';

import { customerApi } from '@/api';

type CustomerCountData = API.FeimaChatCustomerCountListResponse['data'];

interface CustomerStore {
  customerCountData: CustomerCountData;
  setCustomerCountData: (customerCountData: CustomerCountData) => void;
  updateCustomerCountData: (
    params: API.FeimaChatCustomerCountListRequest
  ) => void;
}

// @ts-ignore
export const useCustomerStore = create<CustomerStore>()(set => ({
  customerCountData: {
    allCustomerCount: 0,
    untaggedCustomerCount: 0,
    noBusinessCardCustomerCount: 0,
    hasCollectionBusinessSkill: 0,
  },
  updateCustomerCountData(params) {
    customerApi.feimaChatCustomerCountList(params).then(res => {
      set({ customerCountData: res });
    });
  },
}));
